import * as React from 'react';
import { SubmissionError } from 'redux-form';
import { map, omit } from 'lodash';

import {
  placementCurrentlyEditingAction, placementsRef, savedPlacementAction,
  savingPlacementAction
} from './PlacementOperation';
import { connect } from 'react-redux';
import { PlacementForm } from './placement-form/PlacementForm';
import { clearSavedCharityAction } from '../charity/CharityOperations';

export interface PlacementEditProps {
  match: any;
  charities: Array<any>;
  placements: any;
  saving: boolean;
  saved: boolean;
  setSaving: () => void;
  setSaved: () => void;
  clearSaved: () => void;
  currentlyEditing: any;
  setCurrentlyEditing: (placement: any) => void;
}

class PlacementEditComponent extends React.Component<PlacementEditProps> {
  render() {
    const { charities, saving, saved } = this.props;
    return (
      <div>
        <div className="h3 title is-3">Edit Placement</div>
        {
          saving === true && <div><i className="fa fa-spinner" aria-hidden="true"/> Saving...</div>
        }
        {
          saved === true &&
          <div className="notification is-primary">
            Saved successfully
          </div>
        }
        <PlacementForm
          charities={charities}
          onSubmit={this.onSubmitHandler}
        />
      </div>
    );
  }

  componentDidMount() {
    const placementId = this.props.match.params.uid;
    const { placements, setCurrentlyEditing } = this.props;
    if (placements) {
      const placement = placements[ placementId ];
      if (placement) {
        setCurrentlyEditing({
          ...placement,
          id: placementId
        });
      }
    }
  }

  onSubmitHandler = (values: any) => {
    const { url } = values;

    if (!url) {
      throw new SubmissionError({ name: 'You need to enter a url', _error: 'You need to enter a name!' });
    }

    const charities = omit(values, [ 'id', 'name', 'friendlyId', 'charities', 'active', 'url' , 'createdAt']);
    const charitiesLength = Object.values(charities).length;
    let hasValidCharities = false;
    map(charities, (val) => {
      if (val === true) {
        hasValidCharities = true;
      }
    });

    if (!charitiesLength || !hasValidCharities) {
      throw new SubmissionError({
        [ charities[ 0 ] ]: 'You need to enter a url',
        _error: 'You need to select a charity!'
      });
    }

    const { setSaving, setSaved, clearSaved, currentlyEditing } = this.props;
    setSaving();

    const placement = {
      url,
      charities,
    };
    placementsRef
      .child(currentlyEditing.id)
      .update(placement)
      .then(() => {
        setSaved();
        setTimeout(() => clearSaved(), 3000);
    });
  }
}

const mapStateToProps = ({ charities, placements }) => ({
  charities: charities.all,
  placements: placements.all,
  currentlyEditing: placements.currentlyEditingPlacement,
  saving: placements.saving,
  saved: placements.saved,
});

const mapDispatchToProps = (dispatch) => (
  {
    setSaving: () => dispatch(savingPlacementAction()),
    setSaved: () => dispatch(savedPlacementAction()),
    clearSaved: () => dispatch(clearSavedCharityAction()),
    setCurrentlyEditing: (placement) => dispatch(placementCurrentlyEditingAction(placement))
  });

export const PlacementEdit = connect(mapStateToProps, mapDispatchToProps)(PlacementEditComponent);
